import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { unwrapReactive } from '@jack-henry/frontend-utils/lit';
import { NavigationService } from '@treasury/core/navigation';
import { MessagesService } from '@treasury/domain/channel/services';
import '@treasury/omega/components/omega-button.js';
import { NotificationService, TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-blocking-loader';
import { css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { HeaderBarService } from '../../services/jhd-header-bar.service';
import '../partials/compose-message-form';
import type { Message } from '../types/message.types';

export const tagName = 'compose-message-container';
@customElement(tagName)
export class ComposeMessageContainer extends TmBaseComponent {
    @InjectProperty()
    declare private headerService: HeaderBarService;

    @InjectProperty()
    declare private navService: NavigationService;

    @InjectProperty()
    declare private notificationService: NotificationService;

    @InjectProperty()
    declare private readonly service: MessagesService;

    @state()
    private loading = false;

    @state()
    private messageDetails: Message[] = [];

    protected firstUpdated() {
        this.headerService.configure({
            backAction: () => this.navService.navigate(`/message-center`),
            title: 'New Message',
        });
    }

    protected render() {
        return [this.renderBlockingLoader(), this.renderComposeMessageForm()];
    }

    private async sendMessage(e: CustomEvent) {
        const message = unwrapReactive(e.detail);
        this.loading = true;
        try {
            await this.service.sendMessage(message);
        } catch (err) {
            this.notificationService.renderError(err as Error);
        } finally {
            this.loading = false;
            this.navService.navigate(`/message-center`);
        }
    }

    private renderBlockingLoader() {
        if (!this.loading) {
            return nothing;
        }
        return html`<tm-blocking-loader></tm-blocking-loader>`;
    }

    private renderComposeMessageForm() {
        if (this.loading) {
            return nothing;
        }
        return html` <compose-message-form
            .message=${this.messageDetails}
            @send-message=${(e: CustomEvent) => this.sendMessage(e)}
            @cancel-message=${() => this.navService.navigate(`/message-center`)}
        ></compose-message-form>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ComposeMessageContainer;
    }
}
